<template>
  <div id="app">
    <router-view />
    <vue-confirm-dialog></vue-confirm-dialog>
    <notifications
      group="event"
      position="bottom right"
      animation-type="velocity"
      classes="custom-notifications"
      :duration="5000"
    />
    <!-- Welcome Modal -->
<!--    <WelcomeModal v-if="showWelcome" @close="closeWelcomeModal" />-->
  </div>
</template>

<script>
import WelcomeModal from "./components/WelcomeModal";
export default {
  name: "App",
  components: { WelcomeModal },
  data() {
    return {
      showWelcome: false, // Show the modal on first render
    };
  },
  methods: {
    updateUserInfo() {
      let url = "auth/user";
      this.apiGet(url).then((response) => {
        if (response.data.data) {
          this.$store.dispatch("signIn", {
            access_token: this.$ls.getItem("access_token"),
            data: response.data.data,
            role: response.data.role,
          });
          this.$store.dispatch(
            "updateCalcGaranties",
            response.data.data.calcQuotes
          );
        }
      });
    },
    closeWelcomeModal() {
      this.showWelcome = false; // Hide the modal when closed
    },
  },
  mounted() {
    if (this.$route.name !== 'SignIn' && !this.$route.params.token) {
      this.updateUserInfo();
    }
    // Check local storage to show the modal only once
    if (localStorage.getItem("welcomeShown")) {
      this.showWelcome = false;
    } else {
      this.showWelcome = true;
      localStorage.setItem("welcomeShown", "true");
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue